


















import {
  Vue,
  Component,
  Prop,
} from "@/shared/vuepack";
import moment from "moment";
import { useAccountAlertStore } from "@/shared/store/accountAlert";

@Component
export default class AccountAlert extends Vue {
 accountAlertStore = useAccountAlertStore();

  @Prop()
  content: string;

  @Prop()
  notificationId: number;

  @Prop()
  isRead: boolean;

  @Prop()
  createdDate: string;

  get formattedCreatedDate (): string {
    return moment(this.createdDate).format("MMMM DD, YYYY");
  }

  deleteAlert (): void {
    event.preventDefault();
    this.accountAlertStore.deleteAccountAlert(this.notificationId);
  }

  setAccountAlertRead (): void {
    if (!this.isRead) {
      this.accountAlertStore.setAccountAlertsRead(this.notificationId);
    }
  }
}
